// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__SQAvX","buttons":"RemoveExpirationActionButtons_buttons__33uno"};